module.exports = __webpack_public_path__ + "static/media/blocked_user.8b993649.svg";